import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import uniqueId from 'lodash.uniqueid';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

import { Button } from '../../../../components';

const ImageModal = ({ isOpen, onClose, imageId = uniqueId('evisit_img_'), imageSrc }) => {
	return (
		<Modal isOpen={isOpen} contentLabel="Visit Image" className="modal-dialog">
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">
							Visit Image
						</h3>
					</div>
				</div>
				<div className="modal-body">
					<div className="evisit-image">
						<TransformWrapper>
							{({ zoomIn, zoomOut, resetTransform }) => (
								<React.Fragment>
									<div className="image-tools text-right">
										<Button onClick={zoomIn} icon="plus" />
										<Button onClick={zoomOut} icon="minus" className="mt" />
										<Button onClick={resetTransform} icon="undo" className="mt" />
									</div>
									<TransformComponent>
										<img id={imageId} src={imageSrc} className="transformable-image" />
									</TransformComponent>
								</React.Fragment>
							)}
						</TransformWrapper>
					</div>
				</div>
			</div>
		</Modal>
	);
};

ImageModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	imageId: PropTypes.string,
	imageSrc: PropTypes.string
};

export default ImageModal;
